import { AxiosInstance } from "axios";
import { IEntubaBPFormalizartionRequest } from "src/services/interface/entuba/business-partner/request/formalization/IEntubaBPFormalizationRequest";
import { IEntubaBPResponse } from "src/services/interface/entuba/business-partner/response/entubaResponse";
import { ApiService } from "src/services/model/Api.model";

enum BPEntubaFormalizationServiceEnum {
    start = "/start",
    getAll = "/"
}

export default class BPEntubaFormalizationService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/bp/entuba");
    }

    public start = async (request: IEntubaBPFormalizartionRequest): Promise<IEntubaBPResponse> => await this.POST(BPEntubaFormalizationServiceEnum.start, request);
    public getAll = async (): Promise<any> => await this.GET(BPEntubaFormalizationServiceEnum.getAll);
}


// WEBPACK FOOTER //
// ./src/services/api/BusinessPartner/entuba/formalization/entuba-formalization.service.ts